import React from 'react'
// eslint-disable-next-line no-restricted-imports
import { Viewer, SpecialZoomLevel } from '@react-pdf-viewer/core'

/**
 * Secure wrapper around @react-pdf-viewer/core Viewer that always includes
 * transformGetDocumentParams with isEvalSupported: false to prevent PDF.js vulnerabilities.
 *
 * IMPORTANT: Always use this component instead of importing Viewer directly from
 * @react-pdf-viewer/core to ensure security patches are applied.
 */
const SecureViewer = (props) => {
  const {
    transformGetDocumentParams,
    ...otherProps
  } = props

  // Always ensure isEvalSupported is false, even if user provides their own transformGetDocumentParams
  const secureTransformGetDocumentParams = React.useCallback((params) => {
    const transformed = transformGetDocumentParams
      ? transformGetDocumentParams(params)
      : params

    return {
      ...transformed,
      isEvalSupported: false,
    }
  }, [transformGetDocumentParams])

  return (
    <Viewer
      {...otherProps}
      transformGetDocumentParams={secureTransformGetDocumentParams}
    />
  )
}

export default SecureViewer
export { SpecialZoomLevel }
